import dayjs from 'dayjs'
import L from 'leaflet'

export function watchGeoLocation () {
  console.log('Setting watchGeoLocation...');
  if (window.watchGeoLocationID) {
    navigator.geolocation.clearWatch(window.watchGeoLocationID);
  }
  window.watchGeoLocationID = new Promise(function (resolve, reject) {    
    navigator.geolocation.watchPosition(
      (position) => {
        console.log("watchGeoLocation Success:", position, dayjs().format('YYYY-MM-DD H:mm:ss') )
        let result = {
          position: {lat: parseFloat(position.coords.latitude.toFixed(7)), lng: parseFloat(position.coords.longitude.toFixed(7)) },
          title: 'My location (' + position.coords.latitude.toFixed(7) + ',' + position.coords.longitude.toFixed(7) + ')',
          lat: parseFloat(position.coords.latitude.toFixed(7)),
          lng: parseFloat(position.coords.longitude.toFixed(7)),
          accuracy: position.coords.accuracy,
          speed: position.coords.speed,
          timestamp: dayjs().format('YYYY-MM-DD H:mm:ss'),
        }
        // this.myGeoLocationResult = result
        resolve(result)
        // return result
      },
      (error) => {
        console.log('watchGeoLocation ERROR', error);
        // this.myGeoLocationResult = error
        switch(error.code) {
          case error.PERMISSION_DENIED:
              console.log("User denied the request for Geolocation.")
              break;
          case error.POSITION_UNAVAILABLE:
              console.log("Location information is unavailable.")
              break;
          case error.TIMEOUT:
              console.log("The request to get user location timed out.")
              break;
          case error.UNKNOWN_ERROR:
              console.log("An unknown error occurred.")
              break;
        }
        navigator.geolocation.clearWatch(window.watchGeoLocationID);
        if (error.code === 1) {
          // user denied location so show dialog prompting them to enable location
          // this.showEnableLocationNotice = true
          reject(error)
          // return error
        }
        watchGeoLocation() // try again
      },
      {
      enableHighAccuracy: true,
      maximumAge        : 10000,
      timeout           : 10000
    });
    console.log("watchGeoLocation", window.watchGeoLocationID)
  });
  return window.watchGeoLocationID
}

export function findTotalDistanceFromLatLngs (latLngs = []) {
  return latLngs.reduce((sum, elem, index, arr) => {
    if ((index + 1) >= arr.length) {
      return sum
    }
    let elem1 = arr[index]
    let elem2 = arr[index+1]
    let latLng1 = L.latLng(elem1[0], elem1[1])
    let latLng2 = L.latLng(elem2[0], elem2[1])
    return sum + latLng1.distanceTo(latLng2) // returns meters
  }, 0)
}
